export default __webpack_public_path__ + "static/media/pdf-icon.1df4bf40.svg";